import {
    SET_SERVICE_RULE_CONFIG,
    SET_SERVICE_RULE_LOADING,
    SET_SERVICE_RULE_ERROR,
    UPDATE_SERVICE_RULE_CONFIG,
    CLEAR_SERVICE_RULE_ERROR,
    CLEAR_SERVICE_RULE_DATA,
    CLEAR_ALL_SERVICE_RULE_DATA
} from '@store/types/serviceRuleMasterTypes';

// Action creators
export const setServiceRuleConfig = (configName: string, data: any) => ({
    type: SET_SERVICE_RULE_CONFIG,
    payload: { configName, data }
});

export const setServiceRuleLoading = (configName: string, loading: boolean) => ({
    type: SET_SERVICE_RULE_LOADING,
    payload: { configName, loading }
});

export const setServiceRuleError = (configName: string, error: string | null) => ({
    type: SET_SERVICE_RULE_ERROR,
    payload: { configName, error }
});

export const updateServiceRuleConfig = (configName: string, updates: any) => ({
    type: UPDATE_SERVICE_RULE_CONFIG,
    payload: { configName, updates }
});

export const clearServiceRuleError = (configName: string) => ({
    type: CLEAR_SERVICE_RULE_ERROR,
    payload: { configName }
});

export const clearServiceRuleData = (configName: string) => ({
    type: CLEAR_SERVICE_RULE_DATA,
    payload: { configName }
});

export const clearAllServiceRuleData = () => ({
    type: CLEAR_ALL_SERVICE_RULE_DATA
});